export default "__VITE_ASSET__BjICN$RJ__"